export default "__VITE_ASSET__7c982a92__"